export const TID = {
  navBrand: "nav-brand",
  navWaitlistCta: "nav-waitlist-cta",
  heroTitle: "hero-title",
  heroCta: "hero-cta",
  heroScrollDown: "hero-scroll-down",
  sectionWhy: "section-why",
  sectionClub: "section-club",
  sectionCollections: "section-collections",
  collectionCard: (slug) => `collection-card-${slug}`,
  sectionRoadmap: "section-roadmap",
  roadmapStep: (i) => `roadmap-step-${i}`,
  sectionWaitlist: "section-waitlist",
  waitlistFirstName: "registry-firstname",
  waitlistLastName: "registry-lastname",
  waitlistEmail: "registry-email",
  waitlistCollection: "registry-collection",
  waitlistCollectionOption: (v) => `registry-collection-option-${v}`,
  waitlistCountry: "registry-country",
  waitlistHomeClub: "registry-home-club",
  waitlistNote: "registry-notes",
  waitlistSubmit: "registry-submit",
  waitlistSuccess: "registry-success-message",
  waitlistError: "registry-error-message",
  footer: "site-footer",
};
